import '../sass/pages/MyAccount/ovalia-account.scss';
import { initializeAccountForms } from './utils/account-forms.mjs';
import { initializeAccountTabs } from './utils/account-tabs.mjs';

const initialize = () => {
    const root = document.querySelector('.OvAccount');
    if (root) {
        initializeAccountTabs(root);
        initializeAccountForms(root, window.ovaliaAccount || {});
    }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
else initialize();
